import { transactionConstants } from "actions/types";
import type { TransactionsState } from "types/state";

interface TransactionsAction {
  type: string;
  data?: unknown;
}

const initialState: TransactionsState = {
  transactions: [],
};

export function transactions(
  state: TransactionsState = initialState,
  action: TransactionsAction
): TransactionsState {
  switch (action.type) {
    case transactionConstants.GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: action.data as TransactionsState["transactions"],
      };

    default:
      return state;
  }
}
